<div class="row mb-20">
  <div class="col-12" *ngIf="controparti && controparti.length > 0">
    <p>Controparti associate :</p>
    <app-list-controparti></app-list-controparti>
  </div>
</div>

<div class="row">
  <div class="col-12" *ngIf="!suggested || suggested.length === 0">
    <h5>Nessuna parte suggerita</h5>
  </div>
  <div class="col-12" *ngIf="suggested && suggested.length > 0">
    <h5>Parti suggerite :</h5>
    <app-list-parti (actionEmitter)="action = $event" [action] = "action" [labelComponent] = "'suggested'" *ngIf="suggested.length > 0" [optionsList] = "suggested"></app-list-parti>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <div class="container_tab_nav">
      <ul class="nav nav-tabs two">
        <li [style.width.%]="50" class="{{activeTab === 0 ? 'active' : 'inactive'}}"><a data-toggle="tab" (click)="activeTab = 0"
            aria-expanded="true">Cerca</a></li>
        <li [style.width.%]="50" class="{{activeTab === 1 ? 'active' : 'inactive'}}"><a data-toggle="tab" (click)="activeTab = 1"
            aria-expanded="false">Inserisci</a></li>
      </ul>
      <div class="tab-content">
        <div *ngIf="activeTab === 0"  class="tab-pane fade active in">
          <div searchTextInput #searchElement [url]="requestSearchUrl" (onReturn)="retrieveSearch($event)"></div>
          <app-list-parti (actionEmitter)="action = $event" [action] = "action" [labelComponent] = "'search'" [optionsList] = "options"></app-list-parti>
        </div>
        <div *ngIf="activeTab === 1" class="tab-pane fade active in">
          <app-step-parti-form-inserimento (controparteChange)="retrieveControparte($event)"></app-step-parti-form-inserimento>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row wizard-buttons">
  <p class="col-sm-3 col-xs-6">
    <button type="button" class="btn btn-outline-secondary btn-block" (click)="reset()">Reset</button>
  </p>
  <p
    class="col-sm-3 col-xs-6 col-sm-offset-6">
    <button type='button' class='btn btn-primary btn-block' [disabled]="controparti.length === 0" (click)="salva()">
      Prosegui
    </button>
  </p>
</div>

